import { ProductTypeProps } from "../interface";

  export const getDropDown=()=>{
    
       const getProductTypeDropdown = (
            response:any[]
        ): ProductTypeProps[] => {
            return response
            .filter((value) => value.product_type.name !== 'Lens')
            .map((value) => ({
                value: value.product_type.id,
                label: value.product_type.name,
                code: value.product_type.product_type_initials,
            }));
        };

        return {
            getProductTypeDropdown
        }
   }
   